import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger'
import Tooltip from 'react-bootstrap/lib/Tooltip'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import '../css/FICTooltip.css'

const FICTooltipImpl = (props) => {
  let { children, text, enabled, className, ...tooltipProps } = props
  return <OverlayTrigger {...tooltipProps} overlay={
    <Tooltip id='tooltip' className={'fic-tooltip ' + className + (enabled ? '' : ' fic-tooltip-invisible')}>{text}</Tooltip>
  }>
    {children}
  </OverlayTrigger>
}

FICTooltipImpl.propTypes = {
  trigger: PropTypes.array,
  enabled: PropTypes.bool,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  placement: PropTypes.string
}

FICTooltipImpl.defaultProps = {
  trigger: ['hover', 'focus'],
  enabled: true,
  text: undefined,
  placement: 'top'
}

const FICTooltip = styled(FICTooltipImpl)`
  ul{margin-bottom: 0;}
`

FICTooltip.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  delayShow: PropTypes.number,
  enabled: PropTypes.bool
}

export default FICTooltip



// WEBPACK FOOTER //
// ./src/common/components/js/FICTooltip.js